import { useContext } from 'react';
import AuthContext from './JWTContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
